export const MenuItems = [
  {
    title: "My Profile",
    path: "/",
    cName: "dropdown-link",
  },
  {
    title: "Update Profile",
    path: "/",
    cName: "dropdown-link",
  },
  {
    title: "SignOut",
    path: "/",
    cName: "dropdown-link",
  },
];
